import React from 'react';

interface Props {
  onDismiss: () => void;
}

export const LobbyAlert: React.FC<Props> = ({ onDismiss }) => (
  <div style={{
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.85)',
    zIndex: 200000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  }}>
    <div style={{
      maxWidth: 480,
      width: '100%',
      background: '#0e1e30',
      border: '2px solid #aa8833',
      borderRadius: 10,
      padding: '2rem 2rem 1.5rem',
      fontFamily: 'monospace',
      color: '#d9ecff',
      boxShadow: '0 8px 40px rgba(0,0,0,0.8)',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '1.4rem', color: '#a8d1ff', letterSpacing: '0.06em', marginBottom: '0.5rem' }}>
        HexCrawl
      </div>
      <div style={{
        display: 'inline-block',
        background: 'rgba(255, 180, 0, 0.1)',
        border: '1px solid #aa8833',
        borderRadius: 4,
        color: '#ffdd88',
        fontSize: '0.75rem',
        letterSpacing: '0.12em',
        padding: '0.2rem 0.6rem',
        marginBottom: '1.25rem',
      }}>
        PRE-ALPHA
      </div>
      <p style={{ color: '#b0cce0', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '1rem' }}>
        This game is in early <strong style={{ color: '#ffdd88' }}>Pre-Alpha</strong>. Expect bugs,
        missing content, and breaking changes. Progress may be wiped without notice.
      </p>
      <p style={{ color: '#b0cce0', fontSize: '0.9rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
        Follow development on the{' '}
        <a
          href={`${import.meta.env.VITE_SITE_URL ?? ''}/blog/`}
          target="_blank"
          rel="noreferrer"
          style={{ color: '#5aa0ff', textDecoration: 'underline' }}
        >
          Dev Blog
        </a>.
      </p>
      <button
        onClick={onDismiss}
        style={{
          background: 'rgba(90, 160, 255, 0.15)',
          border: '2px solid #5aa0ff',
          borderRadius: 6,
          color: '#a8d1ff',
          fontFamily: 'monospace',
          fontSize: '0.95rem',
          letterSpacing: '0.05em',
          padding: '0.5rem 2rem',
          cursor: 'pointer',
        }}
      >
        I Understand
      </button>
    </div>
  </div>
);
